import { tw } from '@/utils/tw';

const Strossle = tw.theme({
  base: 'px-6',
});

export default Strossle;
